var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('switcher',{attrs:{"unique-id":_vm.uniqueId,"is-active":_vm.isActiveComputed,"text":_vm.text,"text-inactive":_vm.textInactive,"is-disabled":_vm.isDisabledComputed,"styles":_vm.stylesComputed},on:{"changed":_vm.exportChange}})}
var staticRenderFns = []

export { render, staticRenderFns }